module.exports = __webpack_public_path__ + "img/Lego_Kids_sk.b44102fc.png";